export default __webpack_public_path__ + "static/logo-remote-f8114975768b1a0fd234a345010a966b.svg";